/**
 * Season Summary subtitle templates (Ask #51 council).
 * Pure JS for `node --test`.
 */
import { countryLabel } from './countryFilters.js';

function listOrigins(origins) {
  const labels = (Array.isArray(origins) ? origins : [])
    .map((o) => countryLabel(o))
    .filter(Boolean);
  if (labels.length === 0) return 'the origins';
  if (labels.length === 1) return labels[0];
  if (labels.length === 2) return `${labels[0]} and ${labels[1]}`;
  return `${labels.slice(0, -1).join(', ')}, and ${labels[labels.length - 1]}`;
}

function listDests(codes) {
  const labels = (Array.isArray(codes) ? codes : []).map((c) => countryLabel(c)).filter(Boolean);
  if (labels.length === 0) return 'selected destinations';
  if (labels.length === 1) return labels[0];
  if (labels.length === 2) return `${labels[0]} and ${labels[1]}`;
  return `${labels.slice(0, -1).join(', ')}, and ${labels[labels.length - 1]}`;
}

/**
 * @param {{
 *   destKey: string,
 *   destCodes?: string[],
 *   originCountries?: string[],
 *   destinationCount?: number|null,
 *   seasonLabel?: string|null,
 * }} opts
 */
export function formatSeasonSubtitle({
  destKey,
  destCodes = [],
  originCountries = [],
  destinationCount = null,
  seasonLabel = null,
} = {}) {
  const key = String(destKey || '').trim().toUpperCase();
  const origins = listOrigins(originCountries);
  const season = String(seasonLabel || '').trim();

  if (key === 'NONE') {
    return 'Select a destination to see the season summary.';
  }
  if (Array.isArray(destCodes) && destCodes.length > 1) {
    const dests = listDests(destCodes);
    const suffix = season ? ` ${season}` : '';
    return `Summary of all exports from ${origins} to ${dests}${suffix}`;
  }
  if (key === 'ALL') {
    const n = Number(destinationCount);
    if (Number.isFinite(n) && n > 0) {
      const noun = n === 1 ? 'country' : 'countries';
      return `Summary of all exports from ${origins} to the ${n} ${noun} in the world`;
    }
    return `Summary of all exports from ${origins} to every destination`;
  }
  const dest = countryLabel(key);
  const suffix = season ? ` ${season}` : '';
  return `Summary of all exports from ${origins} to ${dest}${suffix}`;
}
